import SKJ from "../src/images/CustomerLogo/18.jpg";
import SKS from "../src/images/CustomerLogo/33.png";
import Aadhira from "../src/images/CustomerLogo/40.png";
import AJ from "../src/images/CustomerLogo/31.PNG";
import AMR from "../src/images/CustomerLogo/28.png";
import ATM from "../src/images/CustomerLogo/8.jpg";
import ANJ from "../src/images/CustomerLogo/23.png";
import AS from "../src/images/CustomerLogo/11.jpg";
import AVM from "../src/images/CustomerLogo/36.jpg";
import BJ from "../src/images/CustomerLogo/59.png";
import DJM from "../src/images/CustomerLogo/44.jpg";
import DNJ from "../src/images/CustomerLogo/35.jpg";
import RJ from "../src/images/CustomerLogo/13.jpg";
import AUM from "../src/images/CustomerLogo/1- Final Aum Jewellery logo.jpg";
import GST from "../src/images/CustomerLogo/48.png";
import EJ from "../src/images/CustomerLogo/12.jpg";
import IJ from "../src/images/CustomerLogo/19.jpg";
import JMJ from "../src/images/CustomerLogo/34.png";
import JNR from "../src/images/CustomerLogo/30.png";
import JVS from "../src/images/CustomerLogo/46.jpg";
import JP from "../src/images/CustomerLogo/10.jpg";
import KT from "../src/images/CustomerLogo/54.png";
import KV from "../src/images/CustomerLogo/2 Kattlas Vellikada.jpg";
import KN from "../src/images/CustomerLogo/47.png";
import logo1 from "../src/images/CustomerLogo/26.png";
import AJM from "../src/images/CustomerLogo/16.png";
import MGDM from "../src/images/CustomerLogo/57.png";
import MJ from "../src/images/CustomerLogo/14.png";
import MCS from "../src/images/CustomerLogo/58.png";
import MKM from "../src/images/CustomerLogo/41.png";
import NJ from "../src/images/CustomerLogo/5 Natesa Jewellery.png";
import NGD from "../src/images/CustomerLogo/32.jpg";
import PR from "../src/images/CustomerLogo/29.png";
import Radha from "../src/images/CustomerLogo/7.jpg";
import Raga from "../src/images/CustomerLogo/51.png";
import SJ from "../src/images/CustomerLogo/39.png";
import SMSJ from "../src/images/CustomerLogo/21.jpg";
import SRN from "../src/images/CustomerLogo/55.png";
import SKJJ from "../src/images/CustomerLogo/52.png";
import ST from "../src/images/CustomerLogo/24.jpg";
import SSJ from "../src/images/CustomerLogo/56.png";
import SVJ from "../src/images/CustomerLogo/22.jpg";
import SSP from "../src/images/CustomerLogo/45.jpg";
import Subham from "../src/images/CustomerLogo/15.jpg";
import Sumangali from "../src/images/CustomerLogo/27.jpg";
import Swarna from "../src/images/CustomerLogo/8 Swarna Velli Jewels Logo.png.png";
import TRV from "../src/images/CustomerLogo/20.jpg";
import TVM from "../src/images/CustomerLogo/17.jpg";
import Valli from "../src/images/CustomerLogo/21.PNG";
import Velmurugan from "../src/images/CustomerLogo/42 (2).jpg";
import Venkateswara from "../src/images/CustomerLogo/53.png";
import PMR from "../src/images/CustomerLogo/50.png";
import VP from "../src/images/CustomerLogo/42.jpg";
import Vrindhavan from "../src/images/CustomerLogo/4 Vrindhavan Jewels.PNG";
import Muruga from "../src/images/CustomerLogo/61.JPG";
import MC from "../src/images/CustomerLogo/62.JPG";
import PJ from "../src/images/CustomerLogo/Logo transparent (512x512px) PNG (WO- BG).png";
import OG from "../src/images/CustomerLogo/The OG Shop - Final.jpg";
import TS from "../src/images/CustomerLogo/Untitled design (2).jpg";
import BS from "../src/images/CustomerLogo/WhatsApp Image 2024-04-17 at 17.11.36_fa42a835.jpg";

const brand = [
  {
    Image: SKJ,
    title: "Sri Krishna Jewellery",
  },
  {
    Image: MC,
    title: "MuthuCharam - The House of Silver",
  },
  {
    Image: SKJJ,
    title: "SKJ Jewellers",
  },
  {
    Image: TRV,
    title: "TRV Jewellers",
  },
  {
    Image: TVM,
    title: "TVM Abarana Mahaal",
  },
  {
    Image: SKS,
    title: "SKS Nithyam Jewellery",
  },
  {
    Image: Aadhira,
    title: "Aadhira Velli Maaligai",
  },
  {
    Image: AJ,
    title: "Akshara Jewellers",
  },
  {
    Image: AMR,
    title: "AMR Sumangalee Jewellers",
  },
  {
    Image: ATM,
    title: "Amrish Thanga maaligai",
  },
  {
    Image: ANJ,
    title: "Arunachala Nagarani Jewellery",
  },
  {
    Image: AS,
    title: "AS Jewellers",
  },
  {
    Image: AVM,
    title: "AVM Jewellers",
  },
  {
    Image: BJ,
    title: "Bharathy jewellers",
  },
  {
    Image: PJ,
    title: "Pasidi jewels",
  },
  {
    Image: OG,
    title: "The OG Shop",
  },
  {
    Image: DJM,
    title: "Dhana Jewellery Mart",
  },
  {
    Image: RJ,
    title: "Ravindran Jewellers Pvt Ltd",
  },
  {
    Image: AUM,
    title: "Sri Aum Jewellery",
  },
  {
    Image: ST,
    title: "Srinivasa Thangamaaligai",
  },
  {
    Image: Muruga,
    title: "Muruga Jewellery",
  },
  {
    Image: Valli,
    title: "Valli Jewellers",
  },
  {
    Image: SVJ,
    title: "Sri Vishnu Jewellers",
  },
  {
    Image: EJ,
    title: "Eswar Jewellers",
  },
  {
    Image: Swarna,
    title: "Swarna Velli Jewels",
  },
  {
    Image: IJ,
    title: "Iswariyam Jewellery",
  },
  {
    Image: Velmurugan,
    title: "Velmurugan Jewellery",
  },
  {
    Image: JP,
    title: "JP Thanga & Velli Maaligai",
  },
  {
    Image: KV,
    title: "Kattlas Vellikada",
  },
  {
    Image: KN,
    title: "KN Jewellery",
  },
  {
    Image: logo1,
    title: "RR Jewellers",
  },
  {
    Image: AJM,
    title: "Ajoras Jewellery Mart",
  },
  {
    Image: MGDM,
    title: "MGDM",
  },
  {
    Image: MJ,
    title: "Malan Jewellery",
  },
  {
    Image: MCS,
    title: "MCS Jewels",
  },
  {
    Image: NJ,
    title: "Natesa Jewellery",
  },
  {
    Image: NGD,
    title: "Navamani Gold & Diamonds",
  },
  {
    Image: Radha,
    title: "Radha Jewellers",
  },
  {
    Image: Raga,
    title: "Raga Diamond Jewels",
  },
  {
    Image: SMSJ,
    title: "Sree Mayuri Silver Jewellery",
  },
  {
    Image: SRN,
    title: "Sibiraja Nagaimaaligai",
  },
  {
    Image: Subham,
    title: "Subham Jewellery",
  },
  {
    Image: Venkateswara,
    title: "Sree Venkateswara Jewellers",
  },
  {
    Image: PMR,
    title: "PMR Venkateswara Jewellery",
  },
  {
    Image: JVS,
    title: "JVS Jewellery",
  },
  {
    Image: SSJ,
    title: "Sri Swamy Jewellers",
  },
  {
    Image: KT,
    title: "Karthik Thangamaaligai",
  },
  {
    Image: SSP,
    title: "Salem Silver Palace",
  },
  {
    Image: Sumangali,
    title: "Sumangali Jewellers",
  },
  {
    Image: VP,
    title: "VP Jewellery",
  },
  {
    Image: Vrindhavan,
    title: "Vrindhavan Jewels",
  },
  {
    Image: MKM,
    title: "MKM Thangamaaligai",
  },
  {
    Image: JNR,
    title: "JNR Jewellery",
  },
  {
    Image: SJ,
    title: "Saravanas Jewellers",
  },
  {
    Image: PR,
    title: "PR Silver",
  },
  {
    Image: GST,
    title: "Gomathi Shankar Thangamaaligai",
  },
  {
    Image: BS,
    title: "Baskara Silver",
  },
  {
    Image: TS,
    title: "Thangam Swarnamahaal",
  },
  {
    Image: DNJ,
    title: "Dhananithi Jewellery",
  },
  {
    Image: JMJ,
    title: "Jai Maruthi Jewellery",
  },
];

export { brand };
